import RedirectAlertModal from "./redirectAlertModal";

export default RedirectAlertModal;
